export function cepFormatter(cep: string) {
  if (cep) return cep.replace(/^(\d{5})(\d{3})/, "$1-$2");
  return "";
}
